var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("div", { staticClass: "spacer-25" }),
      !_vm.loaded
        ? _c(
            "div",
            [
              _c("v-skeleton-loader", {
                staticClass: "mx-auto",
                attrs: { "max-width": "600", type: "card" },
              }),
            ],
            1
          )
        : _c(
            "v-container",
            { attrs: { "grid-list-xl": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        sm8: "",
                        lg10: "",
                        "offset-sm-2": "",
                        "offset-lg-1": "",
                      },
                    },
                    [
                      _c("NewsCard", {
                        class: { pointer: _vm.hasDeepLink },
                        attrs: { news: _vm.beitrag, "show-all": true },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.clickLink.apply(null, arguments)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }